import { createRouter, createWebHistory } from "vue-router";

const routes = [
  { 
    path: "/", 
    name: "AccueilPage", 
    component: () => import("@/views/Accueil.vue"),
    meta: { title: "Accueil - LeQuinze" }
  },
  { 
    path: "/chambre", 
    name: "ChambrePage", 
    component: () => import("@/views/Chambre.vue"),
    meta: { title: "Nos Chambres - LeQuinze" }
  },
  { 
    path: "/Apropos", 
    name: "ServicesPage", 
    component: () => import("@/views/Services.vue"),
    meta: { title: "Nos Services - LeQuinze" }
  },
  { 
    path: "/mediatheque", 
    name: "PhotothequePage", 
    component: () => import("@/views/Phototheque.vue"),
    meta: { title: "Médiathèque - LeQuinze" }
  },
  { 
    path: "/contact", 
    name: "ContactPage", 
    component: () => import("@/views/Contact.vue"),
    meta: { title: "Contact - LeQuinze" }
  },
  { 
    path: "/reservation", 
    name: "ReservationPage", 
    component: () => import("@/views/Reservation.vue"),
    meta: { title: "Réservation - LeQuinze" }
  },
  { 
    path: "/restaurant_&_bar", 
    name: "BarRestaurantPage",
    component: () => import("@/views/Restaurant.vue"),
    meta: { title: "Bar & Restaurant - LeQuinze" }
  }, 
  { 
    path: "/dashboard", 
    name: "DashboardPage", 
    component: () => import("@/admin/Dashboard.vue"),
    meta: { title: "Tableau de bord - LeQuinze" }
  },
  { 
    path: "/Tb_ss0H6hMSRsQEtI5-VMcNfRm16Bo2kF8zCXLxh0Y0SKxy4zMCLuEIb-9hM44UJx2WIkwk49sgGCQvf76DahvcxYRcUhzOowHr0/login", 
    name: "signin", 
    component: () => import("@/components/LoginPage.vue"),
    meta: { title: "Connexion - LeQuinze" }
  },
  { 
    path: "/Tb_ss0H6hMSRsQEtI5-VMcNfRm16Bo2kF8zCXLxh0Y0SKxy4zMCLuEIb-9hM44UJx2WIkwk49sgGCQvf76DahvcxYRcUhzOowHr0/register", 
    name: "RegisterForm", 
    component: () => import("@/components/RegisterForm.vue"),
    meta: { title: "Inscription - LeQuinze" }
  },
  { 
    path: "/activate", 
    name: "ActivatePage", 
    component: () => import("@/components/ActivateCount.vue"),
    meta: { title: "Activation de compte - LeQuinze" }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,

  // ⭐ Scroll automatique
  scrollBehavior(to, from, savedPosition) {
    // Si on clique sur un lien avec un hash #section
    if (to.hash) {
      return {
        el: to.hash,
        behavior: "smooth",
      };
    }
    // Position sauvegardée (navigation arrière)
    if (savedPosition) {
      return savedPosition;
    }
    // Sinon -> remonter la page
    return { top: 0 };
  }
});

// ⭐ Mise à jour du titre de la page
router.afterEach((to) => {
  document.title = to.meta.title || "LeQuinze";
});

export default router;
